import * as React from 'react';
export const afterpayclearpaySvg = React.forwardRef(
  function afterpayclearpaySvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.955 3.463 10.212.493C8.82-.38 7.08.71 7.08 2.454v.305c0 .275.135.53.354.667l.896.561a.376.376 0 0 0 .398-.001.407.407 0 0 0 .144-.157.439.439 0 0 0 .05-.212V2.86c0-.379.377-.616.679-.426l4.11 2.573c.3.19.3.664 0 .852L9.6 8.433a.433.433 0 0 1-.457-.003.47.47 0 0 1-.165-.18.506.506 0 0 1-.057-.244v-.403c0-1.745-1.742-2.836-3.135-1.963L1.045 8.61c-1.392.873-1.392 3.055 0 3.927l4.743 2.97c1.393.873 3.134-.217 3.134-1.962v-.305a.813.813 0 0 0-.094-.383.755.755 0 0 0-.26-.284l-.896-.562a.376.376 0 0 0-.398.001.408.408 0 0 0-.144.157.439.439 0 0 0-.05.212v.758a.506.506 0 0 1-.057.244.47.47 0 0 1-.165.18.434.434 0 0 1-.457.002l-4.108-2.574a.486.486 0 0 1-.166-.182.522.522 0 0 1 0-.49.486.486 0 0 1 .166-.181L6.4 7.565c.301-.19.68.047.68.426v.403c0 1.746 1.74 2.837 3.133 1.963l4.743-2.97c1.392-.87 1.392-3.052 0-3.924Z',
      }),
    );
  },
);
afterpayclearpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var afterpayclearpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'afterpayclearpay',
  svg: afterpayclearpaySvg,
};
